import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridActionsCellItem, useGridApiRef, GridFooter } from '@mui/x-data-grid-pro';
import Box from '@mui/material/Box';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { render, generateRenderParams } from '../../../common/utils';
import { IconButton } from '@mui/material';
import Close from '@mui/icons-material/Close';


const toolbar = () => {
    return(
        <GridToolbarContainer>
            <Container fluid className='p-0'>
                <Row className='p-0 align-items-center'>
                    <Col></Col>
                    <Col xs='auto' className='text-right'>
                        <GridToolbarQuickFilter />
                    </Col>
                </Row>
            </Container>
        </GridToolbarContainer>
    )
}


const InsertTemplate = ( { user, templates, playbooks, contacts, loans, opps, sid, tid, close, obj, objType, editor, shouldRender, setSelectedTmpl } ) => {
    const [ allTmpls, setAllTmpls ] = useState( {} );
    const [ loading, setLoading ] = useState( true );
    const gridRef = useGridApiRef();
    const [ templateList, setTemplateList ] = useState( [] );
    const [ gridHeight, setGridHeight ] = useState( 400 );

    let cols = [
        { field: 'name', headerName: 'Name', width: 500, renderCell: ( params ) => {
            return (
                <Button variant='link' onClick={ () => insert( params.row.tid ) }>{params.value}</Button>
            )
        } },
    ];

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    const insert = ( tid ) => {
        const tmpl = allTmpls[tid];
        console.log( 'inserting template: ', tid, tmpl );
        if ( tmpl?.body && editor ) {
            let content = tmpl.body;
            console.log( 'setting template: ', tid );
            try {
                setSelectedTmpl( tid );
            } catch ( e ) {
                console.log( 'error setting template: ', e );
            }

            // if ( shouldRender ) {
            //     const params = generateRenderParams( { obj, objType, contacts, loans, opps, user } );
            //     content = render( tmpl.body, params, contacts );
            // }

            // editor.setContent( content );
            close();
        }
    };

    useEffect( () => {
        let temps = {};

        if ( user.meta.templates && user.meta.templates.length ) {
            user.meta.templates.forEach( t => {
                temps[t.tid] = t;
            } );
        }
        if ( user.templates && user.templates.length ) {
            user.templates.forEach( t => {
                temps[t.tid] = t;
            } );
        }

        if ( templates && Object.keys( templates ).length ) {
            Object.keys( templates ).forEach( tid => {
                const t = templates[tid];
                if ( t && t.active === true && t.type === 'email' && t.objects.includes( objType ) && t.version === 2 ) {
                    temps[tid] = t;
                }
            } );
        }

        setAllTmpls( temps );
    }, [ user.templates, user.meta.templates, templates, objType ] );

    useEffect( () => {
        const list = [];
        const tids = Object.keys( allTmpls );
        if ( tids.length ) {
            tids.forEach( tid => {
                const t = allTmpls[tid];
                if ( t && t.objects?.includes( objType ) ) list.push( t );
            } );
            list.sort( ( a, b ) => a.name.localeCompare( b.name ) );
        }
        setTemplateList( list );
        setLoading( false );
    }, [ allTmpls, objType ] );

    return (
        <Fragment>
            <Box sx={style}>
                <Container fluid className=''>
                    <Row className='py-2 px-0' style={{ borderBottom: '1px solid var( --bs-border-color )' }}>
                        <Col className='tf-modal-title'>Insert Template</Col>
                        <Col xs='auto'>
                            <IconButton onClick={close}>
                                <Close fontSize='small' style={ { color: '#000' } } />
                            </IconButton>
                        </Col>
                    </Row>
                    <Row>
                        <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                            <DataGridPro
                                apiRef={gridRef}
                                loading={ loading }
                                rows={templateList}
                                columns={cols}
                                density='compact'
                                disableSelectionOnClick
                                slots={ { 
                                    toolbar: toolbar
                                } }
                                getRowId={ ( row ) => row.tid }
                            />
                        </Col>
                    </Row>
                </Container>
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    user: state.user,
    templates: state.templates.byId,
    playbooks: state.playbooks.byId,
    contacts: state.contacts.byId,
    loans: state.loans.byId,
    opps: state.leadopps.byId,
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( InsertTemplate );